"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Paper_1 = __importDefault(require("@material-ui/core/Paper"));
var InputBase_1 = __importDefault(require("@material-ui/core/InputBase"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Add_1 = __importDefault(require("@material-ui/icons/Add"));
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            padding: '2px 4px',
            display: 'flex',
            alignItems: 'center'
        },
        input: {
            marginLeft: theme.spacing(1),
            flex: 1
        },
        iconButton: {
            padding: 10
        },
        divider: {
            height: 28,
            margin: 4
        }
    });
});
exports["default"] = (function (_a) {
    var _b = _a.label, label = _b === void 0 ? 'add a new message' : _b, onSubmit = _a.onSubmit;
    var classes = useStyles();
    var _c = react_1["default"].useState(''), text = _c[0], setText = _c[1];
    var _d = react_1["default"].useState(false), isLoading = _d[0], setLoading = _d[1];
    var handleSubmit = function (e) {
        if (text === '') {
            return;
        }
        e.preventDefault();
        onSubmit(text).then(function (_x) {
            setLoading(false);
            setText('');
        });
        setLoading(true);
    };
    return (react_1["default"].createElement(Paper_1["default"], { component: "form", onSubmit: handleSubmit, className: classes.root },
        react_1["default"].createElement(InputBase_1["default"], { value: text, disabled: isLoading, onChange: function (v) { return setText(v.target.value); }, className: classes.input, placeholder: isLoading ? 'loading' : label, inputProps: { 'aria-label': 'search google maps' } }),
        react_1["default"].createElement(IconButton_1["default"], { disabled: isLoading, color: "primary", className: classes.iconButton, "aria-label": "directions" },
            react_1["default"].createElement(Add_1["default"], null))));
});
